export default __webpack_public_path__ + "static/media/icon_va_inactive_new.ce560de2.svg";